import { Type } from 'typebox';
import { DailyReport, TypeBoxShortIsoCalendarDateFormat } from '@tadpoles/common';
export const ActivitiesDailyReportParentQueryRequest = Type.Object({
    date: Type.String({ format: TypeBoxShortIsoCalendarDateFormat })
});
export const ActivitiesDailyReportParentQueryPayload = Type.Object({
    dailyReports: Type.Array(DailyReport)
});
export class HttpActivitiesResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async queryDailyReportParent(date, options) {
        return await this.#httpClient.post({
            path: '/activities/daily_report/parent/query',
            body: {
                date
            },
            bodySchema: ActivitiesDailyReportParentQueryRequest,
            payloadSchema: ActivitiesDailyReportParentQueryPayload,
            signal: options?.signal
        });
    }
}
